// mexicoV2TabConfig.ts
// ─── Astria Mexico v2 — per-tab wizard field structure ─────────────────────
// Per client spec (BrMaxico.txt — MX v2 UI JSON: warm, expressive,
// grounded): 6 tabs, each a SINGLE screen (not a multi-step wizard) with
// 1-2 input controls, submitted immediately. Field keys here map 1:1 onto
// the `mexicoV2Wizard` req.body object the backend expects (see
// helper/astriaMexicoV2Service.js / philippinesIndonesiaV2Shared.js header
// comments for the contract).
//
// This file holds only the LANGUAGE-NEUTRAL structure (tab, icon, field
// key/type, chip option values). All displayed text (questions, helper
// copy, field labels, chip option labels) lives in mexicoV2Copy.ts, keyed
// by language — see MexicoV2Tab.tsx for how the two are merged.
import { AstriaMexicoV2Tab } from "./AstriaMexicoV2Shell";

export type MexicoV2FieldType =
  | "emoji_wheel"
  | "slider"
  | "chips"
  | "multi_select"
  | "text";

export interface MexicoV2FieldConfig {
  key:
    | "mood"
    | "intensity"
    | "connection"
    | "tone"
    | "flow"
    | "readiness"
    | "emotion_zone"
    | "location"
    | "issue"
    | "desired"
    | "latest_message"
    | "feeling";
  type: MexicoV2FieldType;
  optionValues?: string[];
}

export interface MexicoV2TabConfig {
  tab: AstriaMexicoV2Tab;
  icon: string; // emoji, per client spec
  fields: MexicoV2FieldConfig[];
}

export const MEXICO_V2_TAB_CONFIGS: MexicoV2TabConfig[] = [
  {
    tab: "soft_summary",
    icon: "🌙",
    fields: [
      { key: "mood", type: "emoji_wheel" },
      { key: "intensity", type: "slider" },
    ],
  },
  {
    tab: "connection_atmosphere",
    icon: "💛",
    fields: [
      {
        key: "connection",
        type: "chips",
        optionValues: ["warm", "distant", "tense", "playful", "quiet"],
      },
      {
        key: "tone",
        type: "chips",
        optionValues: ["gentle", "guarded", "open", "unsure"],
      },
    ],
  },
  {
    tab: "timing_rhythm",
    icon: "⏳",
    fields: [
      {
        key: "flow",
        type: "chips",
        optionValues: ["slow", "steady", "rushed", "uncertain"],
      },
      { key: "readiness", type: "slider" },
    ],
  },
  {
    tab: "emotion_balance",
    icon: "🌤️",
    fields: [
      {
        key: "emotion_zone",
        type: "chips",
        optionValues: ["warm", "heavy", "light", "tender", "steady"],
      },
      {
        key: "location",
        type: "chips",
        optionValues: ["chest", "mind", "stomach", "everywhere"],
      },
    ],
  },
  {
    tab: "guidance_path",
    icon: "🧭",
    fields: [
      {
        key: "issue",
        type: "chips",
        optionValues: ["communication", "distance", "uncertainty", "overwhelm"],
      },
      {
        key: "desired",
        type: "chips",
        optionValues: ["clarity", "closeness", "peace", "courage"],
      },
    ],
  },
  {
    tab: "your_note",
    icon: "📝",
    fields: [
      { key: "latest_message", type: "text" },
      {
        key: "feeling",
        type: "chips",
        optionValues: ["soft", "hopeful", "unsure", "relieved"],
      },
    ],
  },
];
